import React from "react";
import _ from "lodash";
import { MdDelete } from "react-icons/md";
import { IconButton } from "~/components/crud/styles";
import { ImageContainer } from "~/views/persons/styles";
import {
  Autocomplete,
  Checkbox,
  InputDate,
  InputGroup,
  InputMask,
  Select,
} from "~/components/form";
import { MASK_CPF, MASK_PHONE } from "~constants";
import FileImageCrop from "~/components/form/file-image-crop";
import ImageAuth from "~/components/image";
import { ContentContainer } from "~/views/persons/styles";

export const TabGeneral = ({
  errors,
  fromGroup,
  isPress,
  touched,
  values,
  onListRoles,
  previewMode,
  setFieldValue,
}) => {
  return (
    <ContentContainer>
      <Checkbox name="active" label="Ativo" />

      <Select
        name="source"
        label="Origem"
        options={{
          values: [
            { value: "national", label: "Brasil" },
            { value: "international", label: "Estrangeiro" },
          ],
        }}
        hasError={_.get(errors, "source") && _.get(touched, "source")}
      />

      <InputGroup
        type="text"
        name="name"
        label="Nome"
        required={true}
        maxLength={100}
        autoFocus
        disabled={previewMode}
        hasError={errors.name && touched.name}
      />

      {!values.source || values.source === "national" ? (
        <InputMask
          disabled={previewMode}
          mask={MASK_CPF}
          name="identify"
          label={"CPF/Número de regisro(*)"}
          required={true}
          hasError={errors.identify && touched.identify}
        />
      ) : (
        <InputGroup
          type="text"
          maxLength={20}
          disabled={previewMode}
          name="identify"
          label={"CPF/Número de regisro(*)"}
          required={true}
          hasError={errors.identify && touched.identify}
        />
      )}

      <Autocomplete
        name="role"
        keyField="id"
        label="Função"
        clearable={true}
        value={values.role}
        valueFormat={(row) => `${row.name}`}
        loadData={onListRoles}
        emptyText={"Pesquise uma função"}
        tipText={"Digite... "}
        loadingText={"Carregando..."}
        notFoundText={"Não encontrada"}
        disabled={previewMode}
        hasError={errors.role && touched.role}
        onChange={(val) => {
          setFieldValue("role", val);
        }}
      />

      {isPress && (
        <>
          <InputGroup
            type="text"
            name="midia"
            label="Mídia"
            maxLength={100}
            disabled={previewMode}
            hasError={_.get(errors, "midia") && _.get(touched, "midia")}
          />

          <InputGroup
            type="text"
            name="aceesp"
            label="ACEESP"
            maxLength={50}
            disabled={previewMode}
            hasError={_.get(errors, "aceesp") && _.get(touched, "aceesp")}
          />
        </>
      )}

      <InputMask
        type="text"
        name="identityDoc"
        label="RG"
        disabled={previewMode}
        mask={{ numericOnly: true, blocks: [20] }}
        hasError={_.get(errors, "identityDoc") && _.get(touched, "identityDoc")}
      />

      <InputDate
        name="birthdate"
        label="Data de nascimento"
        disabled={previewMode}
        hasError={_.get(errors, "birthdate") && _.get(touched, "birthdate")}
      />

      <InputGroup
        type="email"
        name="email"
        label="Email"
        maxLength={100}
        disabled={previewMode}
        hasError={_.get(errors, "email") && _.get(touched, "email")}
      />

      <InputMask
        name="phone"
        label="Telefone"
        mask={MASK_PHONE}
        disabled={previewMode}
        value={_.get(values, "phone")}
        hasError={_.get(errors, "phone") && _.get(touched, "phone")}
      />

      <InputGroup
        type="text"
        name="registration"
        label="Matrícula"
        maxLength={50}
        disabled={previewMode}
        hasError={
          _.get(errors, "registration") && _.get(touched, "registration")
        }
      />

      {fromGroup && (
        <Select
          name="linkType"
          label="Tipo de vínculo"
          options={{
            values: [
              { value: "terceirizado", label: "Terceirizado" },
              { value: "horista", label: "Horista" },
              { value: "mensalista", label: "Mensalista" },
            ],
          }}
          hasError={_.get(errors, "linkType") && _.get(touched, "linkType")}
        />
      )}

      <ImageContainer>
        <h4>
          <span>Foto</span>
          {values.photo && (
            <IconButton
              title="Limpar imagem"
              onClick={() => setFieldValue("photo", null)}
            >
              <MdDelete />
            </IconButton>
          )}
        </h4>
        {values.photo ? (
          <ImageAuth
            withoutLoading={true}
            src={values.photo ? `/persons/photo/${values.id}/photo` : ""}
          />
        ) : (
          <FileImageCrop
            label="Clique aqui para selecionar a foto"
            name="newPhoto"
            asBase64={true}
            height={"200px"}
          />
        )}
      </ImageContainer>
    </ContentContainer>
  );
};
